export default __webpack_public_path__ + "static/media/event.76b2e7db.svg";